import "core-js/modules/es.array.find";
import "core-js/modules/es.number.constructor";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CloudSealCard from '@tencent/cloud-seal-card';
import IconShare from '@tencent/vft-component/IconShare';
import * as jrQrcode from 'jr-qrcode';
import IconCancel from '@vip-activity/ui/components/icon/IconCancel.vue';
import { buildUrl } from '@tencent/vft-common/url';
import env from '@tencent/vft-common/env';
import { fixShareConfig, cutStrWithEmoji } from '@/util/helper';
import globalConfig from '@/config';
import HuoMask from '../HuoMask/HuoMask.vue';
import config, { transImg } from './config';
export default {
  props: {
    type: {
      type: Number,
      default: 0
    },
    orderid: {
      type: String,
      default: ''
    },
    num: {
      type: Number,
      default: 1
    },
    allNum: {
      type: Number,
      default: 1
    },
    sendDesc: {
      type: String,
      default: '已支持'
    }
  },
  components: {
    IconCancel: IconCancel,
    HuoMask: HuoMask,
    CloudSealCard: CloudSealCard,
    IconShare: IconShare
  },
  data: function data() {
    return {
      key: Date.now(),
      img: '',
      photoIndex: 0,
      mode: 'pic',
      init: false,
      animating: false
    };
  },
  computed: {
    id: function id() {
      if (config[this.type]) {
        return config[this.type].id;
      }

      return config[0].id;
    },
    nick: function nick() {
      var nick = '';

      if (this.userService && this.userService.nick) {
        nick = this.userService.nick;
      }

      return cutStrWithEmoji(nick, 6);
    },
    cardParams: function cardParams() {
      var vipIcon = this.vipService && this.vipService.vipIcon;
      var params = {
        headImg: this.userAvatar,
        qrUrl: this.qrUrl,
        photoSrc: this.photoArr[this.photoIndex],
        bgSrc: this.settingConfig.背景图[this.isLiveEnd ? '点播期' : '直播期'],
        userTypeIcon: this.userTypeIcon,
        nick: this.nick,
        vipIcon: vipIcon || transImg,
        num: this.num,
        ironFans: this.selfTicketCount >= 10,
        ticketDesc: this.ticketDesc,
        sendDesc: this.sendDesc || (this.selfTicketCount ? '已支持' : '已获得'),
        qrCode: this.qrCode
      };
      return params;
    },
    userTypeIcon: function userTypeIcon() {
      if (this.userService) {
        if (this.userService.type === 'wx') {
          return '//puui.qpic.cn/vupload/0/20180728_1532769975346.png/0';
        }

        return '//puep.qpic.cn/vupload/0/20180728_1532769977168.png/0';
      }

      return transImg;
    },
    cardOptions: function cardOptions() {
      var options = {
        x: '',
        y: '',
        maskColor: 'rgba(0, 0, 0, 0)'
      };
      var shareConfig = window.setting.分享图定制;

      if (shareConfig && shareConfig.scale) {
        if (!this.isApp || this.isApp && shareConfig.app下放大) {
          options.scale = shareConfig.scale;
        }
      }

      return options;
    },
    shareInfo: function shareInfo() {
      return {
        imgbase64: this.img
      };
    },
    backData: function backData() {
      if (config[this.type]) {
        return config[this.type];
      }

      return config[0];
    },
    settingConfig: function settingConfig() {
      var list = window.setting.分享图配置 || [];
      return list[this.type] || list[0];
    },
    photoArr: function photoArr() {
      return this.settingConfig.照片回忆图;
    },
    picShareConfig: function picShareConfig() {
      var defaultConfig = window.setting.默认分享;

      var options = _objectSpread(_objectSpread({}, defaultConfig), this.settingConfig);

      if (this.type === 1) {
        options.分享链接 = buildUrl(options.分享链接, {
          userid: globalConfig.vuid,
          orderid: this.orderid,
          hideVideo: 1
        });
      }

      return fixShareConfig(options, {
        user: this.userService || {},
        num: this.num
      });
    },
    // eslint-disable-next-line no-underscore-dangle
    _reportData: function _reportData() {
      if (this.type === 1) {
        return this.reportData.赠送好友;
      }

      return this.reportData.分享票根;
    },
    cardStyle: function cardStyle() {
      if (this.init) {
        return {};
      }

      return {
        opacity: 0
      };
    },
    ticketDesc: function ticketDesc() {
      var _this = this;

      var arr = window.setting.分享门票文案[this.isLiveEnd ? '点播期' : '直播期'];

      if (this.curOrder) {
        var desc = arr.find(function (item) {
          return _this.hitArea(_this.curOrder, item.最小值, item.最大值);
        });

        if (desc) {
          if (this.allNum > 1) {
            return desc.多张文案;
          }

          return desc.单张文案;
        }
      }

      return window.setting.分享门票文案[this.isLiveEnd ? '点播期兜底文案' : '直播期兜底文案'] || '电子票';
    },
    buyList: function buyList() {
      return this.$store.state.buyList || [];
    },
    orderInfo: function orderInfo() {
      return this.$store.state.orderInfo;
    },
    ticketInfo: function ticketInfo() {
      var ticketInfo = this.$store.state.ticketInfo;

      if (Array.isArray(ticketInfo)) {
        return ticketInfo[0];
      }

      return ticketInfo;
    },
    curOrder: function curOrder() {
      var _this2 = this;

      if (this.orderid) {
        return this.orderInfo[this.orderid] || this.buyList.find(function (item) {
          return item.sOrderId === _this2.orderid;
        });
      }

      return this.ticketInfo;
    },
    isApp: function isApp() {
      return env.isApp;
    },
    qrUrl: function qrUrl() {
      var link = this.settingConfig.二维码分享链接 || 'https://m.film.qq.com/vip-activity/huoshao/index.html?ptag=picshare';

      if (this.type === 1) {
        link = buildUrl(link, {
          userid: globalConfig.vuid,
          orderid: this.orderid,
          hideVideo: 1
        });
      }

      return link;
    },
    qrCode: function qrCode() {
      var options = {
        padding: 10,
        // 二维码四边空白（默认为10px）
        width: 256,
        // 二维码图片宽度（默认为256px）
        height: 256,
        // 二维码图片高度（默认为256px）
        correctLevel: 0,
        // 二维码容错level（默认为高）
        reverse: false,
        // 反色二维码，二维码颜色为上层容器的背景颜色
        background: '#ffffff',
        // 二维码背景颜色（默认白色）
        foreground: '#8d427d' // 二维码颜色（默认黑色）

      };
      return jrQrcode.getQrBase64(this.qrUrl, options);
    },
    titlePic: function titlePic() {
      if (this.type === 1 && !this.isLiveOrder) {
        return 'https://vfiles.gtimg.cn/vupload/20200621/2090271592748736575.png';
      }

      return this.settingConfig.分享标题图[this.isLiveEnd ? '点播期' : '直播期'];
    },
    isLiveOrder: function isLiveOrder() {
      try {
        var order = this.curOrder;
        return new Date(order.lCreatTime * 1000) < new Date(window.setting.直播结束时间);
      } catch (e) {
        return false;
      }
    }
  },
  methods: {
    change: function change() {
      if (this.photoIndex >= this.photoArr.length - 1) {
        this.photoIndex = 0;
      } else {
        this.photoIndex += 1;
      }

      this.refreshCard();
    },
    success: function success(img) {
      this.img = img;

      if (!this.init) {
        this.setAnimate();
      }
    },
    close: function close() {
      this.$emit('close');
    },
    setPicShare: function setPicShare() {
      this.share.setShare(this.picShareConfig);
    },
    shareClick: function shareClick(channel) {
      console.log(channel);
    },
    setAnimate: function setAnimate() {
      var _this3 = this;

      this.init = true;
      this.animating = true;
      setTimeout(function () {
        _this3.animating = false;
      }, 2000);
    },
    hitArea: function hitArea(order) {
      var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var start = order.iTicketIDStart;

      if (start >= min && start <= max) {
        return true;
      }

      return false;
    },
    refreshCard: function refreshCard() {
      this.key = Date.now();
    },
    ensureOrderInfo: function ensureOrderInfo() {
      if (this.curOrder && this.curOrder.iTicketIDStart) {
        return;
      }

      if (this.orderid) {// 单独通过orderid去拉取对应的铭牌信息，现在可以不用了，因为川哥那边在购买记录里面返回了
        // this.$store.dispatch('getOrderInfo', this.orderid)
      } else {
        this.$store.dispatch('getTicketInfo');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.share.setShare(this.rootShareConfig);
  },
  mounted: function mounted() {
    this.setPicShare();
    this.ensureOrderInfo();
  }
};